import { ColumnDef } from "@tanstack/react-table";

import { PerformanceLog } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { format } from "date-fns";
import { datesMatch } from "@/utils";
// import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<PerformanceLog>[] {
  return [
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => (
        <div className="w-[180px] flex flex-col">
          <span>{row.index + 1}</span>
          <span className="text-xs">
            (Created at - {format(row.getValue("createdAt"), "PPP")} )
          </span>
        </div>
      ),
      enableSorting: false,
      enableHiding: false,

      filterFn: (row, id, value) => {
        return datesMatch(row.getValue(id), value);
      },
    },
    {
      accessorKey: "addition",
      header: ({ column }) => {
        return (
          <DataTableColumnHeader
            column={column}
            title="Addition in Performance Points"
          />
        );
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("addition")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "deduction",
      header: ({ column }) => {
        return (
          <DataTableColumnHeader
            column={column}
            title="Deduction in Performance Points"
          />
        );
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("deduction")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "reasonPositive",
      header: ({ column }) => {
        return (
          <DataTableColumnHeader column={column} title="Positive Reason" />
        );
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("reasonPositive")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      accessorKey: "reasonNegative",
      header: ({ column }) => {
        return (
          <DataTableColumnHeader column={column} title="Negative Reason" />
        );
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("reasonNegative")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}
